/**
 * Dinheiro na tela, sempre em real — o app é de uma adega de casa, não de
 * importação: uma moeda só, sem campo de moeda para preencher em toda garrafa.
 */
export function emReais(valor: number): string {
  return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/**
 * Sem centavos, para número somado de adega inteira: "R$ 2.847" cabe na linha
 * do celular e ninguém decide nada pelos centavos do total.
 */
export function emReaisRedondo(valor: number): string {
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0,
  });
}
